import React from 'react'
import { useNavigate } from 'react-router-dom'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import moment from 'moment'
import {
  DcBreadcrumbs,
  DcFlexBox,
  PixelPageContainer,
  PixelTable,
  PixelText,
  Section,
  SectionContent,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'

import { getMonthWiseReconciliation } from 'utils/api-routes.util'

export interface IReconciliationHeader {
  id: number
  ems_customer_id: number
  month_: number
  year_: number
  reconciled: number | null
  discrepant: number | null
  inprogress: number | null
  total_orders: number | null
}

const breadcrumbs = [
  {
    name: 'Payment Reconciliation',
    active: true,
  },
]

const columns = [
  {
    dataKey: 'date',
    name: 'Month',
    sortable: true,
    selector: (row) => (
      <PixelText>
        {' '}
        {row.month_ && row.year_
          ? moment({ year: row.year_, month: row.month_ - 1 }).format(
              'MMMM YYYY',
            )
          : '--'}{' '}
      </PixelText>
    ),
  },
  {
    dataKey: 'reconciled',
    name: 'Reconciled',
    sortable: true,
    selector: (row) => <PixelText> {row.reconciled || 0} </PixelText>,
  },
  {
    dataKey: 'discrepant',
    name: 'Discrepant',
    sortable: true,
    selector: (row) => <PixelText> {row.discrepant || 0} </PixelText>,
  },
  {
    dataKey: 'inprogress',
    name: 'InProgress',
    sortable: true,
    selector: (row) => <PixelText> {row.inprogress || 0} </PixelText>,
  },
  {
    dataKey: 'total_orders',
    name: 'Total Orders',
    sortable: true,
    selector: (row) => <PixelText> {row.total_orders || 0} </PixelText>,
  },
]

const ReconciliationMonthWise: React.FC = () => {
  const [reconciliationReport, setReconciliationReport] = React.useState<
    IReconciliationHeader[]
  >([])
  const [tableLoading, setTableLoading] = React.useState<boolean>(false)

  const getReconciliationReport = (): void => {
    setTableLoading(true)
    getMonthWiseReconciliation().subscribe((res: AjaxResponse<IData>) => {
      setReconciliationReport(res.response.data)
      setTableLoading(false)
    })
  }

  React.useEffect(() => {
    getReconciliationReport()
  }, [])

  const navigate = useNavigate()
  const onRowClicked = (row: IReconciliationHeader) =>
    navigate(
      `/analytics/reconciliation-month-wise/details?month=${row.month_}&year=${row.year_}`,
    )

  return (
    <>
      <PixelPageContainer style={{ padding: '0px' }}>
        <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
          <DcFlexBox
            height="60px"
            fontSize="16px"
            style={{
              fontSize: '16px',
              padding: '8px 0px',
              borderBottom: '1px solid #e5e5e5',
            }}
          >
            <DcFlexBox
              justifyContent="space-between"
              alignItems="center"
              padding=".5rem 20px"
            >
              <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />
              <ProfileSection />
            </DcFlexBox>
          </DcFlexBox>
        </SectionContent>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={reconciliationReport}
              progressPending={tableLoading}
              onRowClicked={onRowClicked}
              highlightOnHover={true}
              pointerOnHover={true}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

export default ReconciliationMonthWise
